<template>
  <CommonLayout header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :type="this.consts.meetingType.florist">
      <div class="base-color overflow-auto mh-550 vh-100 shadow">
        <div class="p-2">
          <b-overlay :show="overlayShow" rounded="sm">
            <h5 class="text-dark-blue font-weight-bold pt-3">■お客様情報の入力内容のご確認</h5>
            <form method="post" action="#" class="form-horizontal">
              <div class="px-4">
                <div class="form-group row">
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0"><span class="font-weight-bold header-text-size">ご両家様名</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input header-text-size" id="bothFamilyName"> {{getBothFamilyName1}}・{{getBothFamilyName2}} <span class="pl-3" style="font-size:small">ご両家様</span></div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-12 p-0">
                    <h5 class="font-weight-bold header-text-size">{{shinroShinpu1 !== 'shinro' ? '新婦様' : '新郎様'}}</h5>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>お名前</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break" id="groomName">{{getGroomLastName}} {{getGroomFirstName}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>お名前(カナ)</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="groomNameKana">{{getGroomLastNameKana}} {{getGroomFirstNameKana}}</div>
                  </div>
                  <div class="col-sm-12 row mt-1">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>電話番号</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break" id="groomPhoneNumber">{{getGroomPhoneNumber}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0"><span>メールアドレス</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break header-text-size" id="mailAddress">{{getMailAddress}}</div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-12 p-0">
                    <h5 class="font-weight-bold header-text-size">{{shinroShinpu2 !== 'shinpu' ? '新郎様' : '新婦様'}}</h5>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>お名前</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break" id="brideName">{{getBrideLastName}} {{getBrideFirstName}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>お名前(カナ)</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="brideNameKana">{{getBrideLastNameKana}} {{getBrideFirstNameKana}}</div>
                  </div>
                  <div class="col-sm-12 row mt-1">
                    <div class="col-4 col-lg-3 p-0 pl-3"><span>電話番号</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break" id="bridePhoneNumber">{{getBridePhoneNumber}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0"><span>メールアドレス</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break header-text-size" id="brideMailAddress">{{getBrideMailAddress}}</div>
                  </div>
                </div>
              </div>
              <h5 class="header-bg-txt-color mt-5 mb-0 py-1">【個人情報のお取り扱いについて】</h5>
              <div class="col-sm-12 row px-0 mx-0">
                <div class="col-sm-12 overflow-auto border h-300" style="font-size:small">
                  <template v-for="(t, index) in this.consts.termsMsg.personalInformation">
                    <span :key="`first-${index}`">{{t}}</span>
                    <br :key="`second-${index}`"/>
                  </template>
                </div>
                <div class="col-sm-12 form-group mt-3 d-flex justify-content-center p-2">
                  <!--<div class="border-bottom form-check" :class="{'is-invalid' : validation.hasError('personalInformationCheck')}">-->
                  <!--  <input type="checkbox" class="form-check-input checkbox-scale-larger mt-2" id="personalInformationCheck" true-value="1" false-value="" :class="{'is-invalid' : validation.hasError('personalInformationCheck')}" v-model="personalInformationCheck" disabled>-->
                  <!--  <label class="form-check-label" for="personalInformationCheck">個人情報の取り扱いについて同意する</label>-->
                  <!--</div>-->
                  <label class="form-check-label labex-box-blue py-1 px-4" for="personalInformationCheck" :class="{'is-invalid' : validation.hasError('personalInformationCheck')}">
                    <input type="checkbox" class="checkbox-scale-larger mt-2" id="personalInformationCheck" true-value="1" false-value="" :class="{'is-invalid' : validation.hasError('personalInformationCheck')}" v-model="personalInformationCheck" @click="sendSignalingInputData" :disabled="!isOperationPossible">
                    同意する
                  </label>
                </div>
                <div class="invalid-feedback d-block text-center">{{ validation.firstError('personalInformationCheck') }}</div>
              </div>
              <hr class="border-gray">
              <h5 class="header-bg-txt-color mt-5 mb-0 py-1">【画像の撮影・お取り扱いについて】</h5>
              <div class="col-sm-12 row px-0 mx-0">
                <div class="col-sm-12 overflow-auto border h-300" style="font-size:small">
                  <template v-for="(t, index) in this.consts.termsMsg.imageCheck">
                    <span :key="`first-${index}`">{{t}}</span>
                    <br :key="`second-${index}`"/>
                  </template>
                </div>
                <div class="col-sm-12 form-group mt-3 d-flex justify-content-center p-2">
                  <!--<div class="border-bottom form-check" :class="{'is-invalid' : validation.hasError('personalInformationCheck')}">-->
                  <!--  <input type="checkbox" class="form-check-input checkbox-scale-larger mt-2" id="imageCheck" true-value="1" false-value="" v-model="imageCheck" disabled>-->
                  <!--  <label class="form-check-label" for="imageCheck">画像の取り扱いについて同意する</label>-->
                  <!--</div>-->
                  <label class="form-check-label labex-box-blue py-1 px-4 mr-4" for="imageCheck">
                    <input type="checkbox" class="checkbox-scale-larger mt-2 " id="imageCheck" true-value="1" false-value="" v-model="imageCheck" @change="sendSignalingInputData" :disabled="!isOperationPossible">
                    同意する
                  </label>
                  <label class="form-check-label labex-box py-1 px-4" for="imageCheckDisagree">
                    <input type="checkbox" class="checkbox-scale-larger mt-2" id="imageCheckDisagree" true-value="1" false-value="" v-model="imageCheckDisagree" @change="sendSignalingInputData" :disabled="!isOperationPossible">
                    同意しない
                  </label>
                </div>
              </div>
              <div class="col-sm-12 text-right mb-2 mr-2">
                <b-button variant="outline-primary" class="w-25 sub-button-color back-button-disabled" @click="backPage" :disabled="!isOperationPossible">戻る</b-button>
                <b-button variant="primary" class="w-25 ml-3 main-button-color next-button-disabled" @click="nextPage" :disabled="!isOperationPossible" v-if="loginStatus['referenceFlag'] !== '1'">送信</b-button>
              </div>
            </form>
          </b-overlay>
        </div>
      </div>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import Vue from 'vue'
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import MeetingLayout from '@/layout/MeetingLayout'
import fstore from '@/store/florist-store'
import mstore from '@/store/meeting-store'
import SimpleVueValidation from 'simple-vue-validator'
import SignalingModel from '@/models/SignalingModel'
import CustomerRegistModel from '@/models/CustomerRegistModel'
import CommonLogModel from '@/models/CommonLogModel'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'FloristMeetingConfirm',
  components: { CommonLayout, MeetingLayout, CommonModal, CustomerRegistModel },
  data () {
    return {
      overlayShow: false,
      personalInformationCheck: '',
      imageCheck: '',
      imageCheckDisagree: '',
      loginStatus: '',
      isOperationPossible: false,
      shinroShinpu1: 'shinro',
      shinroShinpu2: 'shinpu'
    }
  },
  computed: {
    getBothFamilyName1 () {
      return fstore.getters.bothFamilyName1
    },
    getBothFamilyName2 () {
      return fstore.getters.bothFamilyName2
    },
    getGroomLastName () {
      return fstore.getters.groomLastName
    },
    getGroomFirstName () {
      return fstore.getters.groomFirstName
    },
    getGroomLastNameKana () {
      return fstore.getters.groomLastNameKana
    },
    getGroomFirstNameKana () {
      return fstore.getters.groomFirstNameKana
    },
    getGroomPhoneNumber () {
      return fstore.getters.groomPhoneNumber
    },
    getBrideLastName () {
      return fstore.getters.brideLastName
    },
    getBrideFirstName () {
      return fstore.getters.brideFirstName
    },
    getBrideLastNameKana () {
      return fstore.getters.brideLastNameKana
    },
    getBrideFirstNameKana () {
      return fstore.getters.brideFirstNameKana
    },
    getBridePhoneNumber () {
      return fstore.getters.bridePhoneNumber
    },
    getMailAddress () {
      return fstore.getters.mailAddress
    },
    getBrideMailAddress () {
      return fstore.getters.brideMailAddress
    },
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },
    getIsOperationPossible () {
      return fstore.getters.isOperationPossible
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (mstore.getters.isTargetAtendeeActive) {
        if (!fstore.getters.bothFamilyName1 ||
          !fstore.getters.bothFamilyName2 ||
          !fstore.getters.groomLastName ||
          !fstore.getters.groomFirstName ||
          !fstore.getters.groomPhoneNumber ||
          !fstore.getters.brideLastName ||
          !fstore.getters.brideFirstName ||
          !fstore.getters.bridePhoneNumber ||
          !fstore.getters.mailAddress ||
          !fstore.getters.brideMailAddress
        ) {
          fstore.commit('setErrorMsg', '値が不正です')
          this.backPage()
        }
      }
    },
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'florist'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })
        console.log('in getSignalingData()')
        console.log('newData:')
        console.log(newData)

        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('customer', 'florist')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (newData['event'] === 'click') {
          if (newData['id'] === 'next') {
            this.signalingNextPage(newData['target_path'])
          }
          if (newData['id'] === 'back') {
            this.signalingBackPage(newData['target_path'])
          }
        }

        if (!fstore.getters.isOperationPossible) {
          if (newData['event'] === 'input') {
            console.log("newData['data']:")
            console.log(newData['data'])
            for (var i = 0; i < newData['data'].length; i++) {
              if (newData['data'][i] && newData['data'][i].id) {
                console.log(newData['data'][i])
                console.log(newData['data'][i].id)
                let elm = document.getElementById(newData['data'][i].id)
                if (!elm) {
                  continue
                }

                // if (elm.classList.contains('form-check-input')) {
                if (elm.getAttribute('type') === 'checkbox') {
                  elm.checked = newData['data'][i].value
                  elm.value = newData['data'][i].value ? 1 : ''
                  // elm.checked = newData['data'][i].value === '1'
                  // elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('change'))
                } else {
                  elm.innerHTML = newData['data'][i].value
                }
              }
            }
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    getIsOperationPossible: function (bool) {
      if (bool) {
        this.isOperationPossible = true
      } else {
        this.isOperationPossible = false
      }
    }
  },
  validators: {
    personalInformationCheck: function (value) {
      return Validator.value(value).required(this.consts.validationMsg.meetingComfirm.personalInformationCheck.required)
    }
  },
  methods: {
    sendSignalingInputData: function (e) {
      try {
        if (this.isOperationPossible) {
          // クリックイベントで呼び出された場合(=引数 e に値が渡されている場合)にidを取得
          const clickedElmID = e ? e.target.id : ''
          if (clickedElmID === 'imageCheck' || clickedElmID === 'imageCheckDisagree') {
            // クリックされたのが、画像利用目的の「同意する」「同意しない」チェックの場合、チェックボックストグル処理を実施
            this.toggleAgreeButton(e.target)
          }

          let sendData = []
          const checkInputs = document.querySelectorAll('input[type="checkbox"]')
          for (let i = 0; i < checkInputs.length; i++) {
            sendData.push({'id': checkInputs[i].id, 'value': checkInputs[i].checked})
          }
          // // 同意チェックボックスの値をシグナリングで送信するデータにセットする
          // sendData.push({'id': 'personalInformationCheck', 'value': this.personalInformationCheck})
          // sendData.push({'id': 'imageCheck', 'value': this.imageCheck})
          // sendData.push({'id': 'imageCheckDisagree', 'value': this.imageCheckDisagree})
          SignalingModel.sendInputEvent(this, sendData)
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    nextPage: async function () {
      try {
        // cookieの打合せIDが変化しているかチェック
        let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
        if (!cookieProjectNumberCheckResult) {
          this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
          return
        }
        let isError = await this.$validate()
          .then((success) => {
            return !success
          })

        if (isError) {
          return false
        }

        let imageFlag = ''
        if (this.imageCheck) {
          imageFlag = '01'
        } else if (this.imageCheckDisagree) {
          imageFlag = '02'
        } else {
          imageFlag = '00'
        }

        const params = {
          'bothFamilyName1': fstore.getters.bothFamilyName1,
          'bothFamilyName2': fstore.getters.bothFamilyName2,
          'groomLastName': fstore.getters.groomLastName,
          'groomFirstName': fstore.getters.groomFirstName,
          'groomLastNameKana': fstore.getters.groomLastNameKana,
          'groomFirstNameKana': fstore.getters.groomFirstNameKana,
          'groomPhoneNumber': fstore.getters.groomPhoneNumber,
          'brideLastName': fstore.getters.brideLastName,
          'brideFirstName': fstore.getters.brideFirstName,
          'brideLastNameKana': fstore.getters.brideLastNameKana,
          'brideFirstNameKana': fstore.getters.brideFirstNameKana,
          'bridePhoneNumber': fstore.getters.bridePhoneNumber,
          'mailAddress': fstore.getters.mailAddress,
          'brideMailAddress': fstore.getters.brideMailAddress,
          'shinroShinpu1': fstore.getters.shinroShinpu1,
          'shinroShinpu2': fstore.getters.shinroShinpu2,
          'personalInformationFlag': this.personalInformationCheck ? '01' : '00',
          'imageFlag': imageFlag
        }

        this.overlayShow = true
        const customerRegistModel = await CustomerRegistModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        if (!customerRegistModel) {
          this.$refs.commonModal.msgBoxOk('お客様情報の更新に失敗しました')
          return false
        }
        if (customerRegistModel.status !== 'success' || customerRegistModel.message) {
          // エラーが発生していた場合
          this.$refs.commonModal.msgBoxOk(customerRegistModel.message)
          return false
        }
        const targetPath = '/florist/meeting/send_mail'
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    signalingNextPage: async function (targetPath) {
      try {
        let isError = await this.$validate()
          .then((success) => {
            return !success
          })

        if (isError) {
          return false
        }
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    backPage: async function () {
      try {
        // cookieの打合せIDが変化しているかチェック
        let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
        if (!cookieProjectNumberCheckResult) {
          this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
          return
        }
        const targetPath = '/florist/meeting/input'
        SignalingModel.sendClickEvent('back', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    signalingBackPage (targetPath) {
      try {
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    toggleAgreeButton (targetElm) {
      try {
        // 「同意する」「同意しない」チェックボックスのON/OFFを切り替える
        if (targetElm.id === 'imageCheck') {
          this.imageCheckDisagree = targetElm.checked ? '' : '1'
          document.getElementById('imageCheckDisagree').checked = !targetElm.checked
        } else {
          this.imageCheck = targetElm.checked ? '' : '1'
          document.getElementById('imageCheck').checked = !targetElm.checked
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  created: function () {
    try {
      this.isOperationPossible = fstore.getters.isOperationPossible
      fstore.commit('setIsOperationPossible', this.isOperationPossible)
      this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))

      // 新郎、新婦の状態を取得
      console.log(fstore.getters.shinroShinpu1)
      console.log(fstore.getters.shinroShinpu2)
      this.shinroShinpu1 = fstore.getters.shinroShinpu1
      this.shinroShinpu2 = fstore.getters.shinroShinpu2
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  }
}
</script>
<style scoped type="text/css">
  .back-button-disabled:disabled {
  background-color: #fff;
  color: rgb(0, 123, 255);
  border-color: rgb(0, 123, 255);
  opacity: 1;
  }
  .next-button-disabled:disabled {
  background-color: rgb(0, 123, 255);
  color: #fff;
  opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/pages/FloristMeetingConfirm.vue